import React from 'react';
import createArtistListRoute from '../utils/artist-list-page';
import ArtistListPage from '../components/common/ArtistListPage';

import {
  selectEnsemblesIsLoading,
  selectNextEnsemblesCursor,
  selectPrevEnsemblesCursor,
  selectEnsembles,
} from '../selectors/ensemble';
import * as ensembleActions from '../actions/ensemble';

const route = createArtistListRoute({
  artistType: 'ensembles',
  selectItems: selectEnsembles,
  selectIsLoading: selectEnsemblesIsLoading,
  selectNextCursor: selectNextEnsemblesCursor,
  selectPrevCursor: selectPrevEnsemblesCursor,
  loadAction: ensembleActions.loadEnsembles,
});

const Ensembles = ({ ...props }) => {
  return <ArtistListPage {...props} />;
};

Ensembles.onDataFetch = route.onDataFetch;

export default route(Ensembles);
